<div class="modal-header" id="address-select-modal-title">
    <h3 class="modal-title" translate="TIMESHEET_ADDRESS_TITLE"></h3>
    <span class="close" (click)="modalInstance.hide()">&times;</span>
</div>
<div class="modal-body">
    <div class="row table-header fw-bold py-2">
        <div class="col-1 limited-col-width"></div>
        <div class="col-5" (click)="setOrderBy('name1.value')">
            <span translate="TIMESHEET_ADDRESS_LIST_NAME"></span>/
            <span translate="TIMESHEET_ADDRESS_LIST_ADDRTEXT"></span>
            @if (orderBy === 'name1.value') {
                <span class="sort-order" [ngClass]="{ reverse: reverse }"></span>
            }
        </div>
        <div class="col-3" (click)="setOrderBy('city.value')">
            <span translate="TIMESHEET_ADDRESS_LIST_CITY"></span>
            @if (orderBy === 'city.value') {
                <span class="sort-order" [ngClass]="{ reverse: reverse }"></span>
            }
        </div>
    </div>

    @for (address of addresses | orderBy: orderBy : reverse; track address) {
        <div>
            <pace-address-select-expandable
                [address]="address"
                [enableHideTimesheetAddress]="enableHideTimesheetAddress"
                [isEditable]="isEditable"
                [isExpanded]="expandedIndex === $index"
                (selectAddressEvent)="selectAddress($index, $event)"
                (deleteAddressEvent)="deleteAddress($index)"
                (hideAddressEvent)="hideAddress($index)"
                (updateAddressEvent)="updateAddress($event)"
                (toggleExpandEvent)="toggleExpand($index)"
                (openHelpEvent)="openHelp($event)"
            ></pace-address-select-expandable>
        </div>
    }
</div>

<div class="modal-footer">
    @if (enableHideTimesheetAddress) {
        <button
            class="btn me-auto btn-warning"
            [disabled]="isResetDeletedAddressesBtnDisabled"
            type="button"
            (click)="resetDeletedAddresses()"
            translate="TIMESHEET_RESET_ADDRESS_LABEL"
        ></button>
    }
    <button
        class="btn btn-primary"
        type="button"
        [disabled]="isNewAddressEntry"
        (click)="displayNewAddressForm()"
        translate="TIMESHEET_NEW_LABEL"
    ></button>
</div>
